import {
  STORE_ACCOUNT,
  STORE_ATTRIBUTES,
  STORE_AUTH_ONBOARDING,
  STORE_BOOST,
  STORE_CHAT,
  STORE_CONSENTS,
  STORE_CONTACTS,
  STORE_EXPLORE,
  STORE_FEEDBACK,
  STORE_FILTERS,
  STORE_INCENTIVES,
  STORE_INSENDIO,
  STORE_LIKES_YOU,
  STORE_MATCH,
  STORE_MEDIA,
  STORE_MM,
  STORE_MUTUAL_FRIENDS,
  STORE_MY_LIKES,
  STORE_NOTIFICATIONS,
  STORE_OPTIMISTIC,
  STORE_PASSPORT,
  STORE_PHOTOS,
  STORE_PROFILE,
  STORE_PURCHASE,
  STORE_RECS,
  STORE_REPORT,
  STORE_SCROLL,
  STORE_SEND_MESSAGES,
  STORE_SPOTIFY,
  STORE_STACKS_UTIL,
  STORE_SUB_OFFER,
  STORE_TINDER_U,
  STORE_UPDATES,
  STORE_VAULT,
  STORE_WEBSOCKET,
} from '../constants';

export type BundleConfigType = {
  name: string;
  initialState?: any;
};

export const asyncInitBundleIndex: BundleConfigType[] = [
  // bundle we load right after init
  { name: STORE_SCROLL },
];

// all async bundle
export const asyncBundleIndex: BundleConfigType[] = [
  { name: STORE_ACCOUNT },
  { name: STORE_ATTRIBUTES },
  { name: STORE_AUTH_ONBOARDING },
  { name: STORE_BOOST },
  { name: STORE_CHAT },
  { name: STORE_CONSENTS },
  { name: STORE_CONTACTS },
  { name: STORE_EXPLORE },
  { name: STORE_FEEDBACK },
  { name: STORE_FILTERS },
  { name: STORE_INCENTIVES },
  { name: STORE_INSENDIO },
  { name: STORE_LIKES_YOU },
  { name: STORE_MATCH },
  { name: STORE_MEDIA },
  { name: STORE_MM },
  { name: STORE_MUTUAL_FRIENDS },
  { name: STORE_MY_LIKES },
  { name: STORE_NOTIFICATIONS },
  { name: STORE_OPTIMISTIC },
  { name: STORE_PASSPORT },
  { name: STORE_PHOTOS },
  { name: STORE_PROFILE },
  { name: STORE_PURCHASE },
  { name: STORE_RECS },
  { name: STORE_REPORT },
  { name: STORE_SCROLL },
  { name: STORE_SEND_MESSAGES },
  { name: STORE_SPOTIFY },
  { name: STORE_SUB_OFFER },
  { name: STORE_STACKS_UTIL },
  { name: STORE_TINDER_U },
  { name: STORE_UPDATES },
  { name: STORE_VAULT },
  { name: STORE_WEBSOCKET },
];
